//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/Expression.js";
let d=[[[1,"LawControl",0,"GeometricUtilities.LawBuilder",0],[1,"Radius",0,"Expression",0],[0,"RadiusOption",1,0]],[[["radius"],"SetRadius",{},1,1],[["radius"],"SetLawControlConstantRadius",{},1,0],[["radius"],"SetLawControlStartRadius",{},1,0],[["radius"],"SetLawControlEndRadius",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.CircularCrossSection = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.CircularCrossSection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.RadiusMethod = Object.freeze({
    "Constant" : "Constant", "Law" : "Law", "Tangency" : "Tangency"});

export default SPLM;